module.exports = {
	"Announcement": {
		"Know More": "詳細"
	},
	"Appointment": {
		"Conditions": "「確認」ボタンをクリックされることにより、お客様はクリスチャン ディオール クチュールのプライバシーポリシーをご確認いただき、弊社がお客様のご要望にお応えする目的においてお客様の個人情報を取り扱うことに同意されるものといたします。",
		"Confirmation": "カスタマイズされたサポートをご利用になるために、ブティックにて弊社アドバイザーとアポイントメントをお取りになりたい旨、確かに承りました。確認メールが間もなくお手元に届きます。",
		"Description": "カスタマイズされたサポートをご利用になるために、ブティックにて弊社アドバイザーとアポイントメントをお取りになることをお勧めいたします。",
		"Get an appointment": "アポイントメントを取る",
		"Motives": "内容",
		"Universes": "カテゴリー"
	},
	"DiorMap": {
		"Search in this area": "この地域内で検索する"
	},
	"FilterBlock": {
		"%(count)s Results": {
			"one": "%(count)s 検索結果",
			"other": "%(count)s 検索結果",
			"zero": "%(count)s 検索結果"
		},
		"Refine": "絞り込む",
		"RefineAria": "以下のチェックボックスで検索を絞り込む",
		"Are you looking for?": "ウィメンズファッション、メンズファッション、ベビー、ジュエリー、ウォッチに関連するブティックをお探しですか？"
	},
	"Footer": {
		"Download the applications": "アプリをダウンロードする",
		"Language": "言語",
		"Newsletter": "例：Christian@dior.fr",
		"Ok": "OK",
		"Subscribe to newsletter": "ニュースレターに登録する"
	},
	"Form": {
		"All fields are mandatory": "すべての項目が必須です",
		"Civility": "敬称",
		"Comments": "コメント",
		"Conditions": "%(brand)sより確認メールをご希望の際は、上の欄にチェックを入れてください。お客様の個人情報に対し、閲覧、修正、削除、異議申し立てを行う権利をお客様自身が有し、\"contact@dior.com\"へご連絡いただくことでその権利を施行することが可能です。",
		"Date": "希望日 ",
		"Email": "メールアドレス",
		"Hour": "希望時間",
		"Invalid E-mail address": "無効なメールアドレス",
		"Mr": "様",
		"Mrs": "様",
		"Name": "姓",
		"Phone": "電話番号",
		"Required fields": "必須フィールド",
		"Submit": "送信",
		"Surname": "名"
	},
	"HeaderLight": {
		"Dior Boutiques near you: haute couture, fragrances, leather goods": "お住まいの街のディオール ブティック：オートクチュール、パルファン、レザーグッズ",
		"Search for Dior shops": "Search for Dior shops",
		"Dior home logo": "DIOR home logo",
		"close boutique finder dialog": "close boutique finder dialog"
	},
	"Itinerary": {
		"Arrival": "出発地",
		"Departure": "到着地",
		"Details": "詳細",
		"Error": "ご希望の行き方が見つかりませんでした。出発地点または交通手段を変更して、再度お試しください。",
		"Follow the itinerary": "移動経路を確認する",
		"Itinerary": "移動経路",
		"modeBICYCLING": "自転車に変更する",
		"modeDRIVING": "自動車に変更する",
		"modeTRANSIT": "公共交通機関に変更する",
		"modeWALKING": "徒歩に変更する",
		"Close dialog": "close dialog",
		"Print directions": "print directions"
	},
	"LayerOrientation": {
		"Use portrait": "ポートレートモードで携帯電話を使用してください"
	},
	"NavMobile": {
		"Home": "ホーム"
	},
	"Newsletter": {
		"Dior Newsletter": "ディオール ニュースレター",
		"Fashion and accessories": "ファッション&アクセサリー",
		"I wish to receive the %(newsletter)s newsletter": "%(newsletter)s の最新情報を希望します",
		"Newsletter Confirmation": "ニュースレターへの登録が完了しました",
		"Perfume and beauty": "フレグランス&ビューティ",
		"Receive our newsletter": "当メゾンのニュースレターを受け取りください",
		"Your universes": "関心のあるカテゴリー"
	},
	"ResultsBlock": {
		"Dior boutiques": "ディオール ブティック",
		"Too far": "結果が多すぎるため、より小さな検索領域を選択し、検索を絞り込んでください。",
		"No result": "店舗は見つかりませんでした",
		"Other shops": "他のブティック",
		"Results": "検索結果",
		"Fewer results, zoom in": "表示を減らす, zoom in",
		"More results, zoom out": "表示を増やす, zoom out",
		"Fewer results": "表示を減らす",
		"More results": "表示を増やす"
	},
	"SearchBlock": {
		"Geolocation": "位置情報を使って最寄りの店舗を探す",
		"Search": "検索する"
	},
	"Share": {
		"Conditions": "%(brand)sより確認メールをご希望の際は、上の欄にチェックを入れてください。お客様の個人情報に対し、閲覧、修正、削除、異議申し立てを行う権利をお客様自身が有し、\"contact@dior.com\"へご連絡いただくことでその権利を施行することが可能です。",
		"Recipient": "店舗情報の送り先",
		"Share Confirmation": "店舗詳細を記載したメールを送信いたしました。",
		"Share this shop": "店舗詳細を送る",
		"Your favorite shop": "選択した店舗"
	},
	"ShopBlock": {
		"Closed": "クローズ",
		"Closed today": "本日休業",
		"Directions": "移動経路",
		"DirectionsAria": "%(shopName)s への行き方",
		"Make an appointment": "アポイントメントを取る",
		"Open": "オープン",
		"Opening time": "開店時間",
		"OpeningAria": "営業時間について",
		"ResultNumber": "結果番号%(number)s",
		"Services": "サービス",
		"ServicesAria": "各種サービスについて",
		"Share": "シェアする",
		"Special hours": "Special hours",
		"Today until %(hour)s": "本日%(hour)sまで",
		"Universes": "カテゴリー",
		"UniversesAria": "関連するカテゴリーについて",
		"and": "and",
		"from": "from",
		"publicHolidays": "誠に勝手ながら、ブティックはクローズしている場合がございます。",
		"to": "to"
	}
};


//////////////////
// WEBPACK FOOTER
// ./public/assets/locales/ja_jp/translations.json
// module id = 868
// module chunks = 0